import React from 'react';
// import { AppsFilterGlyph } from '../../../constants/icons/app-filter';
// import { FolderOpenGlyph } from '../../../constants/icons/folder-open';
// import { LabelGlyph } from '../../../constants/icons/label';
// import { PersonGlyph } from '../../../constants/icons/person';

import CalendarIcon from '@atlaskit/icon/core/calendar';
import FilterIcon from '@atlaskit/icon/core/filter';
import FolderClosedIcon from '@atlaskit/icon/core/folder-closed';
import BulletedListIcon from '@atlaskit/icon/core/list-bulleted';
import PageIcon from '@atlaskit/icon/core/page';
import PersonIcon from '@atlaskit/icon/core/person';
import ProjectIcon from '@atlaskit/icon/core/project';
import SortDescendingIcon from '@atlaskit/icon/core/sort-descending';
import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import TagIcon from '@atlaskit/icon/core/tag';
import { token } from '@atlaskit/tokens';

import { type FilterOrControlId } from '../../../constants/filters';

export const getIcon = ({
	filterOrControlId,
	isSelected,
	label = '',
}: {
	filterOrControlId: FilterOrControlId;
	isSelected: boolean;
	label?: string;
}): React.JSX.Element | null => {
	switch (filterOrControlId) {
		case 'owner':
		case 'assignee':
		case 'contributor':
			return (
				<PersonIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'verified':
			return (
				<StatusVerifiedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'label':
			return (
				<TagIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'content':
			return (
				<BulletedListIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'lastUpdated':
			return (
				<CalendarIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'project':
			return (
				<ProjectIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'space':
			return (
				<FolderClosedIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'onlyTitleMatch':
			return null; // Title match doesn't show an icon, only a checkbox
		case 'universalTypeFilter':
			return (
				<PageIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'dropdown':
			return (
				<FilterIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
		case 'sort':
			return (
				<SortDescendingIcon
					spacing="none"
					label={label}
					color={isSelected ? token('color.icon.selected') : token('color.icon')}
				/>
			);
	}
};
